<button
  class="ap-flex justify-content-between align-items-center w-100 pt-1 pb-1 bg-transparent"
  (click)="toggleAccordion()"
  [disabled]="row().isDisabledAccordionButton">
  <span
    class="Appkit4-icon icon-down-chevron-outline ap-font-16 arrow"
    [class.is-expanded]="row().isRowExpanded"
    [class.is-disabled]="row().isDisabledAccordionButton"
    aria-hidden="true"></span>
</button>
